<div
	class="w-full py-4 px-6 flex justify-center items-center flex-col"
	[class.empty-announcements-default-image]="fullHeight"
>
	<app-image-svg name="search-image" customClass="w-56 lg:w-60 xl:w-64"></app-image-svg>
	<p *ngIf="language === 'es'" class="text-xl text-center mt-7 max-w-[330px]">
		Aquí aparecerán los <span class="font-bold">anuncios</span> cuando sean asignados
	</p>
	<p *ngIf="language === 'en'" class="text-xl text-center mt-7 max-w-[330px]">
		<span class="font-bold">Announcements</span> will appear here when assigned
	</p>
</div>
